<template>
  <div class="i-account">
    <section>
      <iBaseHeader
        highlight-text="Personal Information"
        :version="2"
        font-size-highlighted-text="16px"
        text="View/Update your personal information here"
        font-weight-text="400"
        font-size-text="14px"
        align="start"
      />
      <iPersonalInformation />
    </section>
    <section>
      <iBaseHeader
        highlight-text="Link Accounts"
        :version="2"
        font-size-highlighted-text="16px"
        text="Setup a single sign-on with the accounts below"
        font-weight-text="400"
        font-size-text="14px"
        align="start"
      />
      <iLinkAccounts />
    </section>
    <section v-if="userStore.isCoachingSubscriber || userStore.isActiveReportSubscriber">
      <iBaseHeader
        :highlight-text="userStore.isCoachingSubscriber ? 'Your Coaching Membership' : 'Your Subscription'"
        :version="2"
        font-size-highlighted-text="16px"
        text=""
        font-weight-text="400"
        font-size-text="14px"
        align="start"
      />
      <iCoachingMembership />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useUserStore } from "@/stores/user"

// COMPONENTS
import iBaseHeader from "@/components/base/BaseHeader.vue"
import iPersonalInformation from "@/components/report/account/PersonalInformation.vue"
import iLinkAccounts from "@/components/report/account/LinkAccounts.vue"
import iCoachingMembership from "@/components/report/account/CoachingMembership.vue"

// STORES
const userStore = useUserStore()
</script>

<style scoped lang="scss">
.i-account {
  @include flex($direction: column, $justify: start, $align: stretch, $gap: 35px);

  margin-bottom: 20px;
}
</style>
